import { render, staticRenderFns } from "./appBanner.vue?vue&type=template&id=b2b87b34"
import script from "./appBanner.vue?vue&type=script&lang=js"
export * from "./appBanner.vue?vue&type=script&lang=js"
import style0 from "./appBanner.vue?vue&type=style&index=0&id=b2b87b34&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports